import { HTMLAttributes } from "react";

export default function PlanetScale(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="256"
      height="256"
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="256" height="256" rx="60" fill="black" />
      <g clipPath="url(#clip0_591_28347)">
        <path
          d="M224 128.033C223.982 181.026 181.026 223.982 128.033 224L224 128.033ZM128 32C166.983 32 200.539 55.2355 215.574 88.6125L88.6125 215.574C83.1645 213.12 77.9862 210.172 73.1355 206.788L151.923 128H128L60.1178 195.882C42.7452 178.51 32 154.51 32 128C32 74.9806 74.9807 32 128 32Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_591_28347">
          <rect
            width="192"
            height="192"
            fill="white"
            transform="translate(32 32)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
